import React from 'react';
import { BankTransaction } from '../../../types/bankAccount';
import Avatar from '../misc/Avatar';

interface TransactionProcessorProps {
  transaction: BankTransaction;
}

export default function TransactionProcessor({ transaction }: TransactionProcessorProps) {
  // Handle internal transactions specially - they might not have processing info yet
  if (transaction.transactionType === 'INTERNAL_BANK_TRANSFER') {
    if (transaction.processedByConnection) {
      // If we have processing info, show it
      const { user } = transaction.processedByConnection;
      if (user.userId === -42) {
        return (
          <span className="flex items-center gap-1 text-sm font-medium">
            <img src="/assets/figures/heart.svg" alt="Vera" className="h-4 w-4" /> Ver-AI
          </span>
        );
      }
      return (
        <div className="flex items-center gap-2">
          {user.picture && (
            <Avatar
              src={user.picture}
              alias={`${user.firstName} ${user.lastName}`}
              className="h-6 w-6"
            />
          )}
          <span className="text-sm">
            {user.firstName} {user.lastName}
          </span>
        </div>
      );
    }
    // For internal transactions without processing info (backend not updated yet), show as user processed
    return <span className="text-sm text-gray-600">User Processed</span>;
  }

  // Handle case where backend hasn't been updated yet (processedByConnectionId is null)
  if (transaction.processedByConnectionId === null) {
    return <span className="text-sm text-gray-600">User Processed</span>;
  }

  if (!transaction.processedByConnection) {
    return <span className="text-sm text-gray-500">Not processed</span>;
  }

  const { user } = transaction.processedByConnection;

  // System processing case
  if (user.userId === -42) {
    return (
      <span className="flex items-center gap-1 text-sm font-medium">
        <img src="/assets/figures/heart.svg" alt="Vera" className="h-4 w-4" /> Ver-AI
      </span>
    );
  }

  // User processing case
  return (
    <div className="flex items-center gap-2">
      {user.picture && (
        <Avatar
          src={user.picture}
          alias={`${user.firstName} ${user.lastName}`}
          className="h-6 w-6"
        />
      )}
      <span className="text-sm">
        {user.firstName} {user.lastName}
      </span>
    </div>
  );
}
